import React from "react";
import styled from "styled-components";
import { s3Url } from "../static";
import RepDesignSwiper from "../components/RepDesignSwiper";
import BeadsStringButton from "./projects-button/BeadsStringButton";
import MoruCraft from "./projects-button/MoruCraft";

import { useNavigate } from "react-router-dom";
import Survey from "./Survey";

const BannerImage = () => {
  const imageUrl = `${s3Url}/main_key_visual.png`;
  const items = [
    {
      boardKey: 40,
      imageUrl:
        "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/art/ad12761a-4654-4c4e-ace1-61e5d6c309a7.png",
      status: "POST",
    },
    {
      boardKey: 47,
      imageUrl:
        "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/art/62213eb3-7405-4612-b3d4-d870fadc28e7.png",

      status: "POST",
    },
    {
      boardKey: 48,
      imageUrl:
        "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/art/18e94fe9-9216-4d19-9110-ea51b15bb459.png",

      status: "POST",
    },
    {
      boardKey: 49,
      imageUrl:
        "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/art/a095d9e3-da2c-48a0-932e-36c01dd8e545.png",

      status: "POST",
    },

    {
      boardKey: 51,
      imageUrl:
        "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/art/5b381de4-6226-4d6a-bcff-ea22815765a4.png",

      status: "POST",
    },
    {
      boardKey: 52,
      imageUrl:
        "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/art/269af817-20a2-4ae7-817a-dbeeada32fae.png",
      status: "POST",
    },
    {
      boardKey: 53,
      imageUrl:
        "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/art/315fca33-7c96-43d8-8123-7bfdd1957efd.png",
      status: "POST",
    },
    {
      boardKey: 54,
      imageUrl:
        "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/art/18ebda26-cd10-4166-8d7f-cb0c1b28ac8b.png",
      status: "POST",
    },
    {
      boardKey: 55,
      imageUrl:
        "https://mium-eunsun.s3.ap-northeast-2.amazonaws.com/art/cc394d0a-3d41-4951-806f-fd83034a7bd6.png",
      status: "POST",
    },
  ];
  const navigate = useNavigate();

  const handleViewMore = () => {
    navigate("/projects/moru");
  };
  return (
    <BannerContainer>
      {/* <BannerSwiper> */}
      {/* <ImageContainer
        imageUrl={imageUrl}
        className="rounded-[1rem]"
        onClick={() => navigate("/projects/moru")}
      /> */}
      {/* </BannerSwiper> */}
      <div className="h-[2rem]" />
      <div className="flex flex-wrap  w-full justify-between px-[1rem] text-[1rem]">
        <div className=" font-bold">디자인 생성 방법을 고르세요</div>
        {/* <div className="text-[0.9rem] cursor-pointer" onClick={handleViewMore}>
          더보기 {">"}
        </div> */}
      </div>
      {/* <RepDesignSwiper items={items} /> */}
      <div className="flex gap-3">
        <BeadsStringButton
          onClick={() => {
            console.log("clicked");
            window.location.href =
              "https://diykitten.com/projects/beads-string";
          }}
        />
        <MoruCraft
          onClick={() => {
            console.log("clicked");
            navigate("/projects/moru");
          }}
        />
      </div>
      <Survey />
    </BannerContainer>
  );
};

const BannerContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
`;

const ImageContainer = styled.div`
  width: 100%;
  padding-top: 30.34%; /* This value should be (image height / image width) * 100 */
  background-image: url(${(props) => props.imageUrl});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
`;

export default BannerImage;
